export default "__VITE_ASSET__C8m2DJW2__"